"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconFilter = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconFilter = function SvgIconFilter(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.745 0a.748.748 0 01.595 1.21L7.006 6.753 7 10.291a.75.75 0 01-.22.531l-1.152 1.153a.076.076 0 01-.081.016.075.075 0 01-.047-.069V6.753L1.159 1.21A.747.747 0 011.292.158.757.757 0 011.755 0h8.99z",
    fill: "currentColor"
  }));
};

exports.SvgIconFilter = SvgIconFilter;